var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCopy = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6673 8.59992V11.3999C10.6673 13.7333 9.73398 14.6666 7.40065 14.6666H4.60065C2.26732 14.6666 1.33398 13.7333 1.33398 11.3999V8.59992C1.33398 6.26659 2.26732 5.33325 4.60065 5.33325H7.40065C9.73398 5.33325 10.6673 6.26659 10.6673 8.59992Z",
    fill: "#527BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3998 1.33325H8.59984C6.67914 1.33325 5.71152 1.97018 5.42907 3.49252C5.32748 4.04009 5.79484 4.49992 6.35175 4.49992H7.39984C10.1998 4.49992 11.4998 5.79992 11.4998 8.59992V9.64802C11.4998 10.2049 11.9597 10.6723 12.5072 10.5707C14.0296 10.2882 14.6665 9.32062 14.6665 7.39992V4.59992C14.6665 2.26659 13.7332 1.33325 11.3998 1.33325Z",
    fill: "#527BFF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/copy.a9ac71cb.svg";
export { ForwardRef as ReactComponent };